import { render, staticRenderFns } from "./FileEditorContainer.vue?vue&type=template&id=2b158518&scoped=true"
import script from "./FileEditorContainer.vue?vue&type=script&lang=js"
export * from "./FileEditorContainer.vue?vue&type=script&lang=js"
import style0 from "./FileEditorContainer.vue?vue&type=style&index=0&id=2b158518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b158518",
  null
  
)

export default component.exports